import Vue from "vue";
import Vuex from "vuex";
import Axios from "axios";
import router from "../router";

import { API_URL, getApi } from "@/service/api";
import moment from "moment";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loggedIn: false,
    loading: false,
    user: null,
    error: false,
    trackings: [],
  },

  mutations: {
    LOGIN_REQUEST(state) {
      state.loading = true;
      state.error = false;
    },
    LOGIN_ERROR(state) {
      state.error = true;
      state.loading = false;
      this.user = null;
    },
    LOGIN_SUCCESS(state, payload) {
      state.error = false;
      state.loading = false;
      state.loggedIn = true;
      state.user = payload;
    },
    setTrackings(state, payload) {
      state.loading = true;
      state.loggedIn = true;
      state.trackings = payload;
    },
  },
  actions: {
    GET_ME({ commit }) {
      if (!localStorage.getItem("token")) {
        router.push("/login");
      } else {
        Axios.get(API_URL + "/api/me", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
          .then((res) => {
            const sortByDate = (a, b) => {
              if (
                moment(a.date, "DD-MM-YYYY").isBefore(
                  moment(b.date, "DD-MM-YYYY")
                )
              ) {
                return 1;
              } else if (
                moment(a.date, "DD-MM-YYYY").isAfter(
                  moment(b.date, "DD-MM-YYYY")
                )
              ) {
                return -1;
              } else {
                return 0;
              }
            };

            console.log('res.data.documents', res.data.documents)
            res.data.documents.guias.sort(sortByDate);
            res.data.documents.facturas.sort(sortByDate);
            res.data.documents.recibos.sort(sortByDate);
            res.data.documents.particulares.sort(sortByDate);
            res.data.documents.otros.sort(sortByDate);
            res.data.documents.caratulas.sort(sortByDate);
            res.data.documents.guiasMadre.sort(sortByDate);
            res.data.documents.notasCredito.sort(sortByDate);

            commit("LOGIN_SUCCESS", res.data);
          })
          .catch((error) => {
            console.log("Ocurrio un error", error.data);
            localStorage.removeItem("token");
            commit("LOGIN_ERROR");
          });
      }
    },
    // Tracking
    listTrackings({ commit }) {
      const po_box = localStorage.getItem("po_box");
      if (!localStorage.getItem("token")) {
        router.push("/login");
      } else {
        const response = getApi(API_URL + `/api/tracking/${po_box}`);
        response.then((res) => {
          const listTracking = [
            ...res.data.filter((value) => !value.has_factura),
            ...res.data.filter((value) => value.has_factura),
          ];

          commit("setTrackings", listTracking);
          commit("LOGIN_SUCCESS", this.state.user);
        });
        response.catch((error) => {
          console.log("Error tracking", error.response)
          localStorage.removeItem("token");
          commit("LOGIN_ERROR");
          router.push("/login");
        });
      }
    },
    DO_LOGIN({ commit }, { username, password }) {
      commit("LOGIN_REQUEST");
      localStorage.setItem("po_box", username);
      Axios.post(
        API_URL + "/api/token/",
        { po_box: username, password },
        { headers: { "Content-Type": "application/json" } }
      )
        .then((res) => {
          const token = res.data.access;
          localStorage.setItem("token", token);
          router.push("/home");
          // router.push("/tracking");
          commit("LOGIN_SUCCESS");
        })
        .catch(() => commit("LOGIN_ERROR"));
    },
  },
  modules: {},
});
